import { render, staticRenderFns } from "./ResourcesFolderCard.vue?vue&type=template&id=0e6f50f9&scoped=true&"
import script from "./ResourcesFolderCard.vue?vue&type=script&lang=js&"
export * from "./ResourcesFolderCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesFolderCard.vue?vue&type=style&index=0&id=0e6f50f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f50f9",
  null
  
)

export default component.exports